module.exports = __webpack_public_path__ + "static/media/hypothesis1_success.93aec03f.png";